export default __webpack_public_path__ + "static/media/L_Lampada.58a0567e.mp3";